import { render, staticRenderFns } from "./WarrantyProductInventory.vue?vue&type=template&id=9151b54a&"
import script from "./WarrantyProductInventory.vue?vue&type=script&lang=js&"
export * from "./WarrantyProductInventory.vue?vue&type=script&lang=js&"
import style0 from "./WarrantyProductInventory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports